module.exports = __webpack_public_path__ + "static/media/user-blue.52ce20d0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/user-blue.svg
// module id = 215
// module chunks = 2